/* eslint-disable
    no-alert,
    no-var,
    one-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ProtocolActions from 'notebook/protocols/actions/ProtocolActions';

class CommentBus {
  static initClass() {
    // eslint-disable-next-line no-restricted-syntax
    _.extend(this.prototype, Backbone.Events);

    this.SHOW_STATES = {
      HIDE: 0,
      EXCERPT: 1,
      ALL: 2,
    };

    this.prototype.active = null;
  }

  constructor({user, protocol}) {
    this.user = user;
    this.protocol = protocol;
    this.canComment = this.user != null;
  }

  activate(nextActive) {
    const {linkableID, linkType} = nextActive;
    this.trigger('activate', {
      linkableID,
      linkType,
    });
    this.active = nextActive;
    return this.reflow();
  }

  clearActive() {
    this.trigger('activate', null);
    this.active = null;
    return this.reflow();
  }

  createComment({linkableID, linkType, onDescription, text}) {
    return ProtocolActions.__dangerouslyCommentWithXHR(this.protocol.id, {
      text,
      linkableID,
      linkType,
      onDescription,
    });
  }

  deleteComment({commentID}) {
    if (!window.confirm('Are you sure you want to delete this comment?')) {
      return;
    }
    ProtocolActions.deleteComment(this.protocol.id, commentID);
  }

  canDelete(commentAuthor) {
    return (
      this.protocol.permissions.admin ||
      commentAuthor.url_identifier === (this.user != null ? this.user.url_identifier : undefined)
    );
  }

  reflow() {
    const promises = [];
    this.trigger('prepareReport', promises);
    const isActive = (linkableID, linkType) =>
      this.active != null && this.active.linkableID === linkableID && this.active.linkType === linkType;
    return $.when(...Array.from(promises || [])).done(() => {
      let bottom, linkableID, linkType, position, top;
      let positions = [];
      this.trigger('report', positions);
      positions = _.sortBy(positions, 'top').reverse();
      let activeReserve = null;
      if (this.active != null) {
        for (position of Array.from(positions)) {
          ({top, bottom, linkableID, linkType} = position);
          if (isActive(linkableID, linkType)) {
            activeReserve = {top, bottom};
            break;
          }
        }
      }
      return (() => {
        const result = [];
        for (position of Array.from(positions)) {
          var setState, skip;
          ({top, bottom, setState, linkableID, linkType, skip} = position);
          if (skip) {
            continue;
          }
          let nextMaxBottom = top;
          let nextState = null;
          if (this.active != null && !isActive(linkableID, linkType)) {
            if (activeReserve.top < top && top < activeReserve.bottom) {
              nextState = CommentBus.SHOW_STATES.HIDE;
              nextMaxBottom = maxBottom;
            } else if (activeReserve.top < bottom && bottom < activeReserve.bottom) {
              nextState = CommentBus.SHOW_STATES.EXCERPT;
            }
          }
          if (nextState == null) {
            if (maxBottom != null && bottom >= maxBottom) {
              nextState = CommentBus.SHOW_STATES.EXCERPT;
            } else {
              nextState = CommentBus.SHOW_STATES.ALL;
            }
          }
          var maxBottom = nextMaxBottom;
          result.push(setState(nextState));
        }
        return result;
      })();
    });
  }
}
CommentBus.initClass();

export default CommentBus;
